function Instructions() {
  return (
    <>
      <h4>Levels</h4>
      <p>
        To move up in the ninja world, you must earn a{' '}
        <strong>perfect score</strong> on each level. Think of it like training
        your jutsu where you've got to master it completely before advancing!
        You can practice as many times as you need — just like Naruto never
        gives up.
      </p>
      <p>
        With each level you pass, your character grows stronger and ranks up:
        <br />
        <strong>Genin → Chunin → Jonin → Hokage → Legendary Ninja</strong>
      </p>
      <h4>Review</h4>
      <p>
        {' '}
        You can review the levels you've unlocked by clicking on the review
        button or link at the foot of this page.
      </p>
      <p>
        Keep training, young shinobi, and see if you can reach Hokage status.
        Believe it!
      </p>
    </>
  );
}

export default Instructions;
